export function formatPatientReviewAt(value) {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleString(undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
}

export function getPatientReviewDisplay(patient) {
  if (!patient) return null;
  const at = patient.last_reviewed_at || patient.reviewed_at || null;
  const reviewerId = patient.last_reviewed_by != null && patient.last_reviewed_by !== ''
    ? Number(patient.last_reviewed_by)
    : null;
  const name = String(
    patient.last_reviewed_by_name || patient.reviewed_by_name || patient.reviewer_name || ''
  ).trim();
  const role = String(
    patient.last_reviewed_by_role || patient.reviewed_by_role || patient.reviewer_role || ''
  ).trim();
  const by =
    name ||
    (Number.isFinite(reviewerId) && reviewerId > 0 ? `User #${reviewerId}` : '');

  if (!at && !by) return null;
  return {
    at,
    by,
    role,
    atLabel: formatPatientReviewAt(at),
  };
}

export function getMeasurementReviewDisplay(measurement) {
  if (!measurement) return null;
  const at = measurement.reviewed_at || null;
  const reviewerId =
    measurement.reviewed_by != null && measurement.reviewed_by !== ''
      ? Number(measurement.reviewed_by)
      : null;
  const name = String(measurement.reviewed_by_name || '').trim();
  const role = String(measurement.reviewed_by_role || '').trim();
  const by =
    name ||
    (Number.isFinite(reviewerId) && reviewerId > 0 ? `User #${reviewerId}` : '');
  if (!at && !by) return null;
  return {
    at,
    by,
    role,
    atLabel: formatPatientReviewAt(at),
  };
}

export function isAbnormalVitalStatus(status) {
  return status === 'high' || status === 'low';
}
